import { afterNextRender, ChangeDetectionStrategy, Component, computed, input, OnDestroy } from '@angular/core';
import { ProductCardModelSpecificationGroupSearchProductResponse } from 'src/business/openapi';
import { SearchApiMap } from 'src/business/search';
import { CommonModule } from 'src/common/common.module';
import { ProductCardComponent } from '../product-card/product-card.component';
import { UrlUtil } from 'src/utils/url.util';
import { Uuid } from 'src/utils/uuid.util';
import { clearJsonld, setJsonldFromResults } from 'src/utils/json-ld';

@Component({
  selector: 'app-product-search-list',
  imports: [CommonModule,ProductCardComponent],
  templateUrl: './product-search-list.component.html',
  styleUrl: './product-search-list.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductSearchListComponent implements OnDestroy {
  uuid= Uuid.create();
  ngOnDestroy(): void {
    clearJsonld(this.uuid)
  }

  leaveEmpty = input<boolean>(false);
  title = input<string>('search');
  result = input<ProductCardModelSpecificationGroupSearchProductResponse|null>();
  loading = SearchApiMap.loading;

  lines = computed(() => {
    let res = this.result();
    let loading = this.loading();
    if (loading) {
      clearJsonld(this.uuid)
      return [];
    }
    if(res?.results != null)
    setJsonldFromResults(res?.results,this.uuid,this.title())
    return res?.results ?? [];
  })
  initialValue?: string | null;


}
